export default __webpack_public_path__ + "static/media/mainLogo.270d31f5.jpg";